import * as React from 'react';
import { Route, Switch } from "react-router-dom";
// import HomeComponent from '../components/home/homeComponent';
import MainSceneComponent from '../components/scenes/mainScene/mainScene.Component';
import MainHallComponent from '../components/scenes/mainHall/mainHall.Component';
import EcoStruxureComponent from '../components/common/ecoStruxureComponent';
import EtranceSceneComponent from '../components/scenes/entranceScene/entrance.component';
import AssemblyLineSceneComponent from '../components/scenes/assemblyLineScene/assemblyLineScene.component';
import PanoramaImageComponent from '../components/common/panormicComponent';
import VideoStreamingComponent from '../components/common/videoStreamingComponent';
const NoMatch = () => (
  <div className="app-content">
    <h3>
      URL address <code>location.pathname</code> not match.
    </h3>
  </div>
);

interface IProps {
}

interface IState {
}

class Routes extends React.Component<IProps, IState> {

  public render() {

    return (
      <>
        <Switch>
          <Route exact path="/" component={MainSceneComponent} />
          <Route exact path="/index.html" component={MainSceneComponent} />

          <Route exact path="/main-hall" component={MainHallComponent} />
          <Route exact path="/entrance" component={EtranceSceneComponent} />
          <Route exact path="/assembly-line" component={AssemblyLineSceneComponent} />
          <Route exact path="/eco-struxure" component={EcoStruxureComponent} />
          <Route exact path="/panorama" component={PanoramaImageComponent} />
          <Route exact path="/video" component={VideoStreamingComponent} />
          <Route component={NoMatch} />
        </Switch>
      </>

    )
  }
}


export default Routes;